// store/index.js
import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";

export default createStore({
    state: {
        sessionToken: null,
        myInfo: null,
    },
    getters: {
        getSessionToken: (state) =>{
            return state.sessionToken
        },
        getMyInfo: (state)  => {
            return state.myInfo
        },
    },
    mutations: {
        setSessionToken(state,payload) {
            state.sessionToken = payload.token
        },
        setMyInfo(state, payload) {
            state.myInfo = payload.myInfo
        },
    },
    actions: {
        setSessionToken(context,{token}) {
            context.commit('sessionToken',token);
        },
        initState({ commit }){
            commit({type: 'setMyInfo', myInfo: null});
            commit({type: 'setSessionToken', token: null});
        }
    },
    plugins: [//새로고침 데이터 유지용 추가
        createPersistedState()
    ],
});